'use strict';

var React = require('react');

var SvgEmailNewsletterMajor = function SvgEmailNewsletterMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7 4h6v2h-6v-2zm4 4h-4v2h4v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 10v-8.5a1.5 1.5 0 0 1 1.5-1.5h11a1.5 1.5 0 0 1 1.5 1.5v8.5h2v7.5a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-7.5h2zm2 2v-10h10v10l-5 2.771-5-2.771z"
  }));
};

exports.SvgEmailNewsletterMajor = SvgEmailNewsletterMajor;
